import { Link } from "@mui/material";
import { FunctionComponent, useEffect, useRef, useState } from "react";

import { classNames } from "@/utils/classNames";
import { ExternalLink } from "@/components/ExternalLink/ExternalLink";

export const LeadInfoBox: FunctionComponent<{
	IconElement?: React.ReactNode;
	url?: string;
	content: string | React.ReactNode;
}> = ({ IconElement, url, content }) => {
	const [showContent, setShowContent] = useState(false);
	const [showMore, setShowMore] = useState(false);

	const refContent = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (refContent.current) {
			refContent.current.scrollHeight > refContent.current.clientHeight && setShowMore(true);
		}
	}, [refContent]);

	return (
		<div className={classNames("flex flex-row gap-2  py-2 w-full", showMore ? "items-start" : "")}>
			{IconElement}

			<div className="grow text-ellipsis overflow-hidden line-clamp-3 max-w-fit text-left flex flex-col items-start justify-start">
				<p
					ref={refContent}
					className={classNames(
						"text-ellipsis overflow-hidden line-clamp-3 max-w-full text-sm text-text-meta",
						showContent ? "line-clamp-none" : "line-clamp-3",
						!showMore ? "cursor-default" : "cursor-pointer"
					)}
					onClick={() => setShowContent(!showContent)}
				>
					{content}
				</p>
				{showMore && (
					<div
						className="text-sm text-text-meta cursor-pointer underline mt-2"
						onClick={() => setShowContent(!showContent)}
					>
						{showContent ? "Less..." : "More..."}
					</div>
				)}
			</div>
			{url && (
				<Link className="text-sm text-text-meta" href={url} target="_blank">
					<ExternalLink />
				</Link>
			)}
		</div>
	);
};
